import React from 'react';
import '../styles/NotFound.css';
import ContactForm from '../components/ContactForm';

export default function NotFound(){
  return (
    <div className="container">
      <h1>404</h1><p>Page not found.</p>
    </div>
  );
}
